import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";

export default function PageNotFound() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="md">
        <Grid container spacing={2}>
          <Grid item xs={6} mt="auto " mb="auto">
            <Typography variant="h3" fontWeight="bold">
              ACCESS DENIED!
            </Typography>
            <Typography variant="subtitle2">
              Sorry you have no access to this page.
            </Typography>
            <Box display="flex" justifyContent="center" mt={4}>
              <Button variant="contained" mt={1} onClick={() => navigate(-1)}>
                Back to previous page
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <img src="https://i.imgur.com/qIufhof.png" alt="" width={500} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
